export const categories = [
    {
        value: 'art',
        label: 'Art'
    },
    {
        value: 'music',
        label: 'Music'
    },
    {
        value: 'domain_names',
        label: 'Domain Names'
    },
    {
        value: 'virtual_world',
        label: 'Virtual World'
    },
    {
        value: 'trading_cards',
        label: 'Trading Cards'
    },
    {
        value: 'collectibles',
        label: 'Collectibles'
    },
    {
        value: 'sports',
        label: 'Sports'
    },
    {
        value: 'utility',
        label: 'Utility'
    }
];

export const status = [
    {
        value: 'buy_now',
        label: 'Buy Now'
    },
    {
        value: 'on_auction',
        label: 'On Auction'
    },
    {
        value: 'has_offers',
        label: 'Has Offers'
    },
];

export const itemsType = [
    {
        value: 'single_items',
        label: 'Single Items'
    },
    {
        value: 'bundles',
        label: 'Bundles'
    }
];

export const collections = [
    {
        value: 'abstraction',
        label: 'Abstraction'
    },
    {
        value: 'patternlicious',
        label: 'Patternlicious'
    },
    {
        value: 'skecthify',
        label: 'Skecthify'
    },
    {
        value: 'cartoonism',
        label: 'Cartoonism'
    },
    {
        value: 'virtuland',
        label: 'Virtuland'
    },
    {
        value: 'papercut',
        label: 'Papercut'
    }
];